// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__FlQ9h","primaryLabel":"Switch_primaryLabel__cfSn3","switchContainer":"Switch_switchContainer__zVXcv"};